// extracted by mini-css-extract-plugin
export default {"botao_novo":"BotaoPaginaNovo_botao_novo__AGw+1"};